'use client';

import React from 'react';

import { PortalRecovery } from './components/PortalRecovery';

interface IGlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

const GlobalError = ({ error, reset }: IGlobalErrorProps): React.ReactElement => (
  <html lang="en">
    <body>
      <PortalRecovery source="global-error" onRetry={reset} error={error} />
    </body>
  </html>
);

export default GlobalError;
